/**
 * ChannelIcon - small colored icon by channel type.
 */
import { channelByType } from "@/lib/channels";

export default function ChannelIcon({ type, className = "h-4 w-4", showBg = false }) {
    const meta = channelByType(type);
    if (!meta) return null;
    const Icon = meta.icon;
    if (showBg) {
        return (
            <span
                className={`inline-flex items-center justify-center rounded-md ${meta.bg} text-white p-1`}
                title={meta.name}
            >
                <Icon className={className} />
            </span>
        );
    }
    return <Icon className={className} style={{ color: meta.color }} aria-label={meta.name} />;
}
